import { PERMISSIONS, terraContract } from '@terra/shared-authorization';
import { z } from 'zod';
import { INTERNAL_NETWORK_PATH_NAME } from './internal-network.constants';
import {
  InternalNetworkCveRetestJobListResponseSchema,
  InternalNetworkCveRetestJobSchema,
  TriggerInternalNetworkCveRetestBodySchema,
} from './internal-network-cve-retest.schema';

const NetworkParamsSchema = z.object({ networkId: z.string() });

export const InternalNetworkCveRetestContract = terraContract
  .prefix(`/${INTERNAL_NETWORK_PATH_NAME}`)
  .router({
    listCveRetestJobs: terraContract
      .meta({
        permissions: [PERMISSIONS.VIEW_INTERNAL_NETWORK.name],
      })
      .route({
        method: 'GET',
        path: '/{networkId}/cve-retest',
        summary: 'List internal-network CVE retest jobs',
        inputStructure: 'detailed',
      })
      .input(z.object({ params: NetworkParamsSchema }))
      .output(InternalNetworkCveRetestJobListResponseSchema),
    startCveRetest: terraContract
      .meta({
        permissions: [PERMISSIONS.MANAGE_INTERNAL_NETWORK.name],
      })
      .route({
        method: 'POST',
        path: '/{networkId}/cve-retest',
        summary: 'Match CVE IDs against fingerprinted internal hosts',
        inputStructure: 'detailed',
        successStatus: 201,
      })
      .input(
        z.object({
          params: NetworkParamsSchema,
          body: TriggerInternalNetworkCveRetestBodySchema.optional(),
        }),
      )
      .output(InternalNetworkCveRetestJobSchema),
  });
